<template>
  <div>
    <side-bar
      :menus="menus"
    />
    <div class="page">
      <router-view
      />
    </div>
  </div>
</template>
<script>
  import SideBar from '@/components/layouts/SideBar';

  export default {
    data() {
      return {
        menus: [
          {
            icon: 'fa fa-balance-scale',
            label: '급여/공제 항목 관리',
            routeName: 'base-property.index',
            super: false
          }
        ]
      }
    },
    components: {
      SideBar
    }
  }
</script>
